import {getCreateOrderBody} from "./OrderReducers";
import {AuthorizationUtils} from "../utils/AuthorizationUtils";
import {SUBFORM_OPEN} from "./subforms/SubformsActions";
import {MODALS_OPEN, MODALS_TYPE_MESSAGE} from "../common/modals/ModalsConstants";

export const ORDER_CREATE = 'ORDER_CREATE';
export const ORDER_CREATED = 'ORDER_CREATED';
export const ORDER_REQUEST_DATA = 'ORDER_REQUEST_DATA';
export const ORDER_CREATED_FAILURE = 'ORDER_CREATED_FAILURE';
export const ORDER_FORM_VALUES = 'ORDER_FORM_VALUES';
export const ORDER_CHANGE_CUSTOMER = 'ORDER_CHANGE_CUSTOMER';
export const ORDER_CHANGE_PERSONA = 'ORDER_CHANGE_PERSONA';
export const ORDER_CHANGE_BILLING_ADDRESS = 'ORDER_CHANGE_BILLING_ADDRESS';
export const ORDER_CHANGE_SHIPPING_ADDRESS = 'ORDER_CHANGE_SHIPPING_ADDRESS';
export const ORDER_FORM_RESET = 'ORDER_FORM_RESET';

export const ORDER_CUSTOMER_CREATED = 'ORDER_CUSTOMER_CREATED';

export const FORM_CHANGE = 'FORM_CHANGE';

export const changeForm = (formName) => (dispatch) => {
  dispatch({
    type: FORM_CHANGE,
    action: formName
  });
};

export const resetForm = () => (dispatch) => {
  dispatch({
    type: ORDER_FORM_RESET
  });
};

export const openSubform = (subformName) => (dispatch) => {
  dispatch({
    type: SUBFORM_OPEN,
    action: subformName
  });
};

export const create = (formValues, config, finish) => (dispatch) => {
  const showModalMessage = (message, type, title) => {
    dispatch({
      type: MODALS_OPEN,
      modalType: MODALS_TYPE_MESSAGE,
      content: {
        messageModal: {
          title,
          message: JSON.stringify(message, null, 2),
          type
        }
      }
    });
  };

  dispatch({
    type: ORDER_CREATE
  });

  fetch(`${config.api.baseUrl}/orders`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': AuthorizationUtils.base64(config.environment.merchantId, config.environment.apiKey)
    },
    body: JSON.stringify(getCreateOrderBody(formValues))
  })
    .then(response => response.json())
    .then(
      (result) => {
        if (result.status && result.status >= 400) {
          dispatch({type: ORDER_CREATED_FAILURE, error: result});
          showModalMessage(result, 'error', 'Error response');
        } else {
          dispatch({type: ORDER_CREATED, order: result});
          finish();
          showModalMessage(result, 'success', 'Order created successfully');
        }
      },
      (error) => {
        dispatch({type: ORDER_CREATED_FAILURE, error: error});
        showModalMessage(error, 'error', 'Error response');
      }
    )
    .catch(
      (error) => {
        dispatch({type: ORDER_CREATED_FAILURE, error: error});
        showModalMessage(error, 'error', 'Error response');
      }
    );
};

export const skip = () => (dispatch) => {
  dispatch({type: ORDER_CREATED, order: {}});
};

export const saveFormValues = (formValues) => (dispatch) => {
  dispatch({type: ORDER_FORM_VALUES, formValues});
};

export const saveOrderRequestData = (formValues, finish) => (dispatch) => {
  dispatch({type: ORDER_CREATED, order: {}});
  dispatch({type: ORDER_REQUEST_DATA, orderRequestData: getCreateOrderBody(formValues)});
  finish();
};



// WEBPACK FOOTER //
// ./src/order/OrderActions.js